const GEONAMES_USERNAME = 'anamnesis'; // À remplacer par votre username
const GEONAMES_API = 'https://secure.geonames.org';

export interface GeonamesResult {
  geonameId: number | string;
  name: string;
  lat: string;
  lng: string;
  adminName1: string;
  countryName: string;
  [key: string]: any;
}

export const searchGeonames = async (query: string): Promise<GeonamesResult[]> => {
  try {
        const response = await fetch(
            `${GEONAMES_API}/searchJSON?q=${encodeURIComponent(query)}&maxRows=10&username=${GEONAMES_USERNAME}`
          );
    const data = await response.json();
    return data.geonames || [];
  } catch (error) {
    console.error('Erreur lors de la recherche Geonames:', error);
    return [];
  }
}; 
